export const email = "interventions@diplomeavantlamedaille.org";
export const phone = "418-431-0115";